import { useContext, useEffect } from 'react';
import { COOKIES_KEYS, getCookie } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { bulletSubscribe, bulletUnsubscribe } from '@namespace/socket';
import { UserContext, useUserInfoLoaded } from '@namespace/user';
import { IS_WIDGET, WidgetContext } from '@namespace/widget';

export const useSSID = () => {
  const [{ ssid: widgetSSID }] = useContext(WidgetContext);
  const { language } = useI18n();
  const [user] = useContext(UserContext);
  const { role } = user;
  const { userInfoLoaded } = useUserInfoLoaded();

  // important, subscription is needed here for reconnection case
  useEffect(() => {
    if (userInfoLoaded) {
      const ssid = IS_WIDGET ? widgetSSID : getCookie(COOKIES_KEYS.PHPSESSID);

      if (ssid) {
        bulletSubscribe({
          name: 'user-ssid',
          types: [],
          message: { user_ssid: ssid },
          callback: () => {}
        });
      }

      return () => bulletUnsubscribe('user-ssid');
    }

    return () => {};
    // `role` dependency is necessary here to re-subscribe to the bullet 'user-ssid'
    // when the user role changes from 'guest' to 'user'. Do not remove it as it ensures
    // that the subscription updates correctly based on the user's role change.
  }, [language, userInfoLoaded, widgetSSID, role]);
};
